import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Premium blog card with image, category badge, title, excerpt, meta.
 * If no image is provided, shows a branded gradient placeholder.
 *
 * Props:
 *   slug      - blog slug for link
 *   title     - blog title
 *   excerpt   - short description
 *   image     - thumbnail URL (optional — falls back to CSS gradient)
 *   category  - category label
 *   date      - publication date string
 *   readTime  - e.g. "5 min read"
 */
const placeholderStyle = {
  width: '100%',
  height: '100%',
  background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0000 60%, #f42222 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(255,255,255,0.25)',
  fontSize: 24,
  fontWeight: 900,
  letterSpacing: 2,
};

const BlogCard = ({ slug, title, excerpt, image, category, date, readTime }) => {
  const linkPath = slug ? `/blog-details/${slug}` : '/blogs';

  return (
    <Link to={linkPath} className="rr-blog-card">
      <div className="rr-blog-card__img-wrap">
        {image ? (
          <img
            src={image}
            alt={title}
            className="rr-blog-card__img"
            loading="lazy"
          />
        ) : (
          <div style={placeholderStyle}>RIDE N REPAIR</div>
        )}
        {category && (
          <span className="rr-blog-card__category">{category}</span>
        )}
      </div>
      <div className="rr-blog-card__body">
        <div className="rr-blog-card__title">{title}</div>
        {excerpt && <div className="rr-blog-card__excerpt">{excerpt}</div>}
        <div className="rr-blog-card__meta">
          {date && <span>{date}</span>}
          {readTime && <span>{readTime}</span>}
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
